module.exports = __webpack_public_path__ + "static/media/icon_cut.773a6476.png";